import { render } from "./profile-mobile-footer-nav.vue?vue&type=template&id=6ab9eab2&scoped=true"
import script from "./profile-mobile-footer-nav.vue?vue&type=script&lang=js"
export * from "./profile-mobile-footer-nav.vue?vue&type=script&lang=js"

import "./profile-mobile-footer-nav.vue?vue&type=style&index=0&id=6ab9eab2&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ab9eab2"]])

export default __exports__